export const PRESCORE_UPDATE_USER_INFO = 'PRESCORE_UPDATE_USER_INFO';
export const PRESCORE_UPDATE_OFFER = 'PRESCORE_UPDATE_OFFER';
export const PRESCORE_RESET = 'PRESCORE_RESET';
export const PRESCORE_SET_LOADING = 'PRESCORE_SET_LOADING';
export const PRESCORE_SET_UTM = 'PRESCORE_SET_UTM';
export const PRESCORE_REMOVE_UTM = 'PRESCORE_REMOVE_UTM';
export const PRESCORE_V2_UPDATE_VERIFICATION_ID =
  'PRESCORE_V2_UPDATE_VERIFICATION_ID';
export const PRESCORE_V2_UPDATE_USER_INFO = 'PRESCORE_V2_UPDATE_USER_INFO';

export const PRESCORE_V2_UPDATE_OTP_TOKEN = 'PRESCORE_V2_UPDATE_OTP_TOKEN';

export const OFFERS_TYPE = {
  CCX: 'CCX',
  CLX: 'CLX',
  ACLX: 'ACL',
  ACL: 'ACLX',
  CLXEL: 'CLX_EL_OFFER',
};

export const OFFERS_TRACKING_TYPE = {
  ACL: 'ACL',
  ACLX: 'ACLX',
};

export const ACCEPTED_OFFER_TYPES = {
  CLX: 'CLX',
  CREDIT_CARD: 'CREDIT_CARD',
  HOME_PAYLATER: 'HOME_PAYLATER',
};

export const ACCEPTED_PREFIX_CODE_OFFERS = {
  [ACCEPTED_OFFER_TYPES.CLX]: ['CLX_'],
  [ACCEPTED_OFFER_TYPES.CREDIT_CARD]: ['CCX_', 'SCW_'],
  [ACCEPTED_OFFER_TYPES.HOME_PAYLATER]: ['BNPL_', 'APOS'],
};

export const OTP_CODE = {
  waiting: 5000,
  notFoundClient: 404,
  noOffersFound: 1036,
  invalidOffers: 1043,
  foundOffers: 0,
  onMaintain: -99,
  scoringFailed: -98,
  invalidOTP: 1045,
};
export const API_ROOT = {
  search: '/api/prescore/search',
  verify: '/api/prescore/verify',
  verifyScoring: '/api/prescore/verify-scoring',
  getOffers: '/api/bod-get-offers',
  recallOffers: '/api/bod-recal-offers',
  config: '/api/prescore/config',
  codeGenerate: '/api/prescore/codeGenerate',
  getReccoringOffers: '/api/bod-get-recal-offers',
};
export const PATHS = {
  waiting: 'tinh-toan',
  notFoundClient: 'vay-nhanh-10-phut',
  noOffersFound: 'tinh-toan-khong-thanh-cong',
  invalidOffers: 'tinh-toan-khong-thanh-cong',
  foundOffers: 'tinh-toan-thanh-cong',
  verifyOtp: 'xac-thuc-otp',
};
export const KEY_STORE = 'prescore';
export const MINI_GAME_GENERATE = {
  haveOffer: 'web_score_offer',
  noOffer: 'web_score_no_offer',
};

export const SLEEP_TIME = 30000;
export const WAITING_TIME = 180000;
export const NOT_MATCHED = 'NOT_MATCHED';
export const HOTLINE = '18006860';
export const TEL_HOTLINE = `tel:${HOTLINE}`;
